// extracted by mini-css-extract-plugin
module.exports = {"root":"Leaderboard_root__1LRzZ","header":"Leaderboard_header__3X7EN","dates":"Leaderboard_dates__En6hr","divider":"Leaderboard_divider__3ILTw"};